import { useEffect, useMemo } from 'react';
import Layout from '../../components/Layout';
import classes from './styles.module.scss';
import { Heading } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import queryString from 'query-string';

const REFERRAL_INVITE_UTM = {
  utm_source: 'incash_app',
  utm_medium: 'referral',
  utm_campaign: 'refer_a_friend',
};

const REFERRAL_PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.incash.money.earning&utm_source=incash_app&utm_medium=referral&utm_campaign=refer_a_friend';

export default function Referral() {
  const router = useRouter();

  const params = useMemo(() => {
    if (typeof window !== 'undefined') {
      return Object.fromEntries(new URLSearchParams(window.location.search));
    }
    return {};
  }, [router.asPath]);

  const referralUrl = useMemo(() => {
    if (Object.keys(params).length === 0) {
      return REFERRAL_PLAY_STORE_URL;
    }

    const cleanedParams = removeNullValues(params);
    const decodedReferrer = cleanedParams?.referrer?.replaceAll('&', ' ');

    const payload = {
      ...REFERRAL_INVITE_UTM,
      ...cleanedParams,
      referrer: decodedReferrer?.trim() === '' ? '--' : decodedReferrer,
    };

    const encodedParams = encodeURIComponent(queryString.stringify(payload));

    return `${REFERRAL_PLAY_STORE_URL}&referrer=${encodedParams}`;
  }, [params]);

  useEffect(() => {
    if (referralUrl && !referralUrl.endsWith('&referrer=')) {
      window.location.href = referralUrl;
    }
  }, [referralUrl]);

  return (
    <Layout>
      <div className={classes.Referral}>
        <Heading as="h1">Redirecting...</Heading>
      </div>
    </Layout>
  );
}

function removeNullValues(obj) {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined) {
      delete obj[propName];
    }
  }
  return obj;
}
